
import Vue from "vue";
import { MailConfig } from "@/utils/mail-config";
import { MessagesService } from "@/services/messages-service";

export default Vue.extend({
	data() {
		return {
			email: "",
			pending: false,
			error: false,
			isGoogle: false,
			isOutlook: false,
			isRequired: false,
			showPassword: false,
			password: "",
			config: null as MailConfig | null
		};
	},
	methods: {
		close() {
			this.$emit("close");
		},
		save() {
			if (!this.config) {
				this.isRequired = true;
				return;
			}
			this.config.Password = this.password;
			this.$emit("save", this.config);
			this.$emit("close");
		},
		async start() {
			if (this.password == "") {
				this.isRequired = true;
				return;
			}
			this.pending = true;
			this.config = await MessagesService.autoMailConfig(this.email);
			this.error = !this.config.Host;
			this.isGoogle = this.config.Host.includes("google.com");
			this.isOutlook = this.config.Host.includes("protection.outlook.com");
			this.config.UserName = this.email;
			if (this.error || this.isGoogle || this.isOutlook) {
				this.config = null;
				this.pending = false;
				return;
			}
			this.save();
			this.pending = false;
		}
	},
	components: {},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
